export const GET_SINGLE_USER = 'GET_SINGLE_USER'
export const GET_USER_PURCHASE = 'GET_USER_PURCHASE'
export const GET_USER_SPENDINGS = 'GET_USER_SPENDINGS'
